import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { User } from '../models/profile/user';

@Injectable()
export abstract class AuthServiceBase {
  protected userSubject = new BehaviorSubject<User | null>(null);
  public userInfo = this.userSubject.asObservable();

  public get currentUser(): User | null {
    return this.userSubject.value;
  }

  public abstract isUserSignedIn(): boolean;
  public abstract startAuthentication(): void;
  public abstract signOut(): void;
  public abstract completeAuthentication(): Promise<void>;
  public abstract getAccessToken(scopes?: string[]): Promise<string | null>;
  public abstract updateToken(scopes?: string[]): Promise<string | null>;
  public abstract hasRole(role: string): boolean;

  constructor(protected router: Router) { }
}
